export const hostname = (): string => globalThis.location?.hostname;
